import { computed, ref } from "vue";
import { useSettingsStore } from "@/store/settings";
import { comingSoonImages } from "@/helpers/composables/comingSoonImages"
import {
    productUploadImageUrl,
    productUploadImageResponsiveFromFilename,
    PRODUCT_IMAGE_SIZES_CART_THUMB
} from "@/helpers/productUploadImageUrl";

interface listItem {
    list_item_id: number;
    quantity: number;
    variation: Object;
    price: string;
}

interface list {
    list_id: number;
    total: string;
}

export function useCartDetails (
    list_item?: listItem,
    list?: list,
    source: string = "cart"
 ) {

    let settingsStore = useSettingsStore();

    const userType = computed(() => settingsStore.userType);

    const currencySymbol = "$";

    const availableFields = {
        b2b: [
            "unit_price",
            "total_quantity",
            "total_skus",
            "total_styles",
            "item_no",
            "subtotal",
            "quantity",
            "apply_promo_later",
            "b2b_cart_msg"
        ],
        b2c: [
            "free_shipping_msg",
            "unit_price", 
            "total_quantity",
            "subtotal", "quantity", 
            "free_shipping_msg",
            "discounts", 
            // "bnlp_message", 
            "apply_coupon", 
            "dealer_checkout_btn", 
            "show_b2c_cards"
        ]
    };

    const isPropertyVisible = (property) => {
        return availableFields[userType.value].includes(property);
    };
    
    let subTotal = computed(() => {
        return `${parseFloat(list.value.total || 0).toFixed(2)}`;
    });
    list_item = ref(list_item);
    let listItem = computed(() => {
        if (!list_item.value?.list_item_id) {
            return {
                list_item_id: null,
                price: 0,
                formattedPrice: `${currencySymbol}0.00`,
                formattedOrigPrice: `${currencySymbol}0.00`,
                formattedSubtotal: `${currencySymbol}0.00`,
                item_no: null,
                quantity: 0,
                original_quantity: 0,
                promoMsg: '',
                item: {
                    item_name: '',
                    seo_name: '',
                    formattedVariants: '',
                    variants: {},
                    inventory_level: 0,
                    item_picture: null,
                    item_picture_srcset: undefined as string | undefined,
                    item_picture_sizes: undefined as string | undefined,
                    item_picture_medium: null
                }
            };
        }
        const price = parseFloat(list_item.value.price || 0).toFixed(2);
        const origPrice = parseFloat(list_item.value.unit_price || 0).toFixed(2);
        const subtotal = (list_item.value.subtotal || 0).toFixed(2);
        return {
            list_item_id: list_item.value.list_item_id,
            formattedPrice: `${currencySymbol}${price}`,
            formattedOrigPrice: `${currencySymbol}${origPrice}`,
            formattedSubtotal: `${currencySymbol}${subtotal}`,
            item_no: list_item.value.variation?.rothcoItem?.rothco_item_no,
            quantity: list_item.value.quantity,
            original_quantity: list_item.value.quantity,
            promoMsg: '',
            item: list_item.value.variation?.item ? (() => {
                const fn = list_item.value.variation?.primary_image?.image_filename;
                if (fn) {
                    const pack = productUploadImageResponsiveFromFilename(
                        fn,
                        PRODUCT_IMAGE_SIZES_CART_THUMB
                    );
                    return {
                        item_name: list_item.value.variation.item.name,
                        seo_name: list_item.value.variation.item.seo_name,
                        formattedVariants: Object.values(list_item.value.variation.text_description || {}).join(' | '),
                        variants: list_item.value.variation.text_description,
                        inventory_level: list_item.value.variation.inventory_level,
                        item_picture: pack.src,
                        item_picture_srcset: pack.srcSet,
                        item_picture_sizes: pack.sizes,
                        item_picture_medium: productUploadImageUrl(fn, "medium")
                    };
                }
                return {
                    item_name: list_item.value.variation.item.name,
                    seo_name: list_item.value.variation.item.seo_name,
                    formattedVariants: Object.values(list_item.value.variation.text_description || {}).join(' | '),
                    variants: list_item.value.variation.text_description,
                    inventory_level: list_item.value.variation.inventory_level,
                    item_picture: comingSoonImages().small,
                    item_picture_srcset: undefined,
                    item_picture_sizes: undefined,
                    item_picture_medium: comingSoonImages().small
                };
            })() : {
                item_name: '',
                seo_name: '',
                formattedVariants: '',
                variants: {},
                inventory_level: 0,
                item_picture: null,
                item_picture_srcset: undefined as string | undefined,
                item_picture_sizes: undefined as string | undefined,
                item_picture_medium: null
            }
        };
    });    

    return {
        isPropertyVisible,
        currencySymbol,
        listItem,
        subTotal
    };
}
